import { Alert } from "@/components/ui";

// FormAlert is the auth forms' error banner (login, 2FA, forgot, reset). It is the
// kit's `Alert` plus two things those forms need and the rest of the app does not:
// it renders nothing when there is no error (so every caller is `<FormAlert
// message={err} />` rather than a conditional), and it announces itself politely -
// the message often arrives without the user having submitted anything, as a
// throttle lockout counts down.
export function FormAlert({
  message,
  className = "mb-5",
}: {
  message: string | null;
  className?: string;
}) {
  if (!message) return null;
  return <Alert aria-live="polite" className={className}>{message}</Alert>;
}
